import { required, email,minLength, maxLength } from '@vuelidate/validators'

export default {
	
	methods: {
		/** MODAL METHODS */
		resetModal() {
			// this.msgError = ''
			this.$store.dispatch('initFlash');
			this.dataMapShow.attrsList = []
			this.datepicker = {
				selectedDate: '',
				selectedFormatted: '',
				locale: this.$i18n.locale,
				// messages: this.$i18n.messages[this.$i18n.locale].datepicker.labels
			}
		},
		handleCancel() {this.modalToggle()},
		filterList(row, resu){
			let filtered = resu;
			if (row)
				filtered = resu.filter(item => (item.id != row.id) && item.parent?.id != row.id);
			return filtered;
		},
		/** FORM METHODS */
		async buildFormModel() {
			// FOR MODEL USABILITY : TRANSFER TO the form data
			for (let index = 0; index < this.dataMapShow.attrsList.length; index++) {
				const eachAttr = this.dataMapShow.attrsList[index];
				if (eachAttr){
					this.form[eachAttr.attrName] = eachAttr.attrValue;
					if (eachAttr.vueRules){
						// vueRules: {form: {}} default value
						this.vueRules.form[eachAttr.attrName] = eachAttr.vueRules

					}
				}
			}
			// this.v$.form.$reset()
			// console.log ('this.vueRulesvfor user ==', this.vueRules)
		},
		
		async handleResult(type) {
			this.file = [] // on init
			if (type === 'new') {
				this.dataMapShow.infos.id = null;
				this.row = null;
				this.dataMapShow.infos.title = 'default.add';
				this.dataMapShow.readOnlyShow = false;
				if(this.v$.form != null)
					this.v$.form.$reset()
			} 
			else if (type === 'edit') {
				this.dataMapShow.infos.title = 'default.edit';
				this.dataMapShow.readOnlyShow = false;
				this.v$.$validate()
			}
			else if (type === 'editPwd') {
				this.dataMapShow.infos.title = 'default.editPwd';
				this.dataMapShow.readOnlyShow = false;
				this.v$.$validate()
			}
			else if (type === 'delete') {
				this.dataMapShow.infos.title = 'default.delete';
				this.dataMapShow.readOnlyShow = false;
			} 
			else {
				this.dataMapShow.infos.title = 'default.show';
				this.dataMapShow.readOnlyShow = true;
				this.v$.$validate()
			}

			// TRAITEMENT POUR CHAQUE TYPE
			if (this.instanceClass === 'user') {
				let attrSelectListRole = [];
				let attrSelectListPerson = [];
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// EP -> 1
				strParams = strParams+"&aliasList=_prsType"
				strParams = strParams+"&params1=_prsType.id&valParams1="+1+"&logParams1=eqL"
				strParams = strParams+"&params2=active&valParams2="+true+"&logParams2=eqB"
				await this.$store.dispatch('axiosGet', {
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then((response) => {
					attrSelectListPerson = response.data;
				})
				.catch((error) => {
					if (error.response)
						this.modalShow = true;
				});

				this.roleslist = [];
				await this.$store.dispatch('axiosGet', {
					url: '/api/role/paginate',
				})
				.then((response) => {
					attrSelectListRole = response.data.rows;

					for (let i = 0; i < attrSelectListRole.length; i++) {
						this.roleslist.push({
							id: attrSelectListRole[i].id,
							name: attrSelectListRole[i].authority,
						});
					}

					// Hide/Show password
					var passwordDisplay = (type === 'new' || type === 'editPwd') ? '' : 'none';
					var editPwd = (type === 'editPwd') ? 'none' : '';

					var roleSelected = [], attrSelectedList = [];
					// Array of edit selected roles object
					if (this.row && this.row.id && this.row.roles) {
						for (let i = 0; i < this.row.roles.length; i++) {
							roleSelected.push(this.row.roles[i]);
						}
					} 
					else
						roleSelected = [];

					// Array of only selected roles names
					for (let j = 0; j < roleSelected.length; j++) {
						for (let k = 0; k < this.roleslist.length; k++) {
							if (roleSelected[j].id == this.roleslist[k].id) {
								attrSelectedList.push(this.roleslist[k].name)
								break;
							}
						}
					}

					this.dataMapShow.attrsList = [
						{
							attrName: 'email',
							attrType: 'String',
							attrCol: 'col-md-6',
							attrValue: this.row ? this.row.email : '',
							attrReadOnly: false,
							attrRequired: true,
							attrDisplay: editPwd,
							attrOnRow: false,
							vueRules:{required, email}

						},
						
						{
							attrName: 'username',
							attrType: 'String',
							attrCol: 'col-md-6',
							attrValue: this.row ? this.row.username : '',
							attrReadOnly: false,
							attrRequired: true,
							attrDisplay: editPwd,
							attrOnRow: false,
							vueRules:{required, minLength: minLength(3)}
							// veeRules:{required: true, regex: /[a-z0-9\\.@]$/, min: 4},
						},
						{
							attrName: 'password',
							attrType: 'password',
							attrCol: (type === 'editPwd') ? 'col-md-12' : 'col-md-4',
							attrValue: this.row ? this.row.password : '',
							attrReadOnly: false,
							attrRequired: true,
							attrDisplay: passwordDisplay,
							attrOnRow: true,
							// vueRules:{required}
						},
						{
							attrName: 'passwordExpiration',
							attrType: 'Date',
							attrCol: 'col-md-4',
							attrValue: this.row ? this.$moment(this.row.passwordExpiration).format('YYYY-MM-DD').toString() : '',
							attrReadOnly: false,
							attrRequired: true,
							attrDisplay: editPwd,
							attrOnRow: true,
							vueRules:{required}
						},
						{
							attrName: 'enabled',
							attrType: 'radio',
							attrCol: 'col-md-4',
							attrValue: this.row ? this.row.enabled : false,
							attrReadOnly: false,
							attrRequired: false,
							attrDisplay: editPwd,
							attrOnRow: true,
							vueRules:{required}
						},
						
						{
							attrName: 'personId',
							attrType: 'Select',
							attrCol: 'col-md-8',
							attrValue: (this.row && this.row.personId) ? this.row.personId : '',
							attrReadOnly: false,
							attrRequired: false,
							attrDisplay: editPwd,
							attrSelectList: attrSelectListPerson,
							attrSelectOption: 'fullName',
							vueRules:{required}
						},
						{
							attrName: 'userTitle',
							attrType: 'String',
							attrCol: 'col-md-4',
							attrValue: this.row ? this.row.userTitle : '',
							attrReadOnly: false,
							attrRequired: true,
							attrDisplay: editPwd,
							attrOnRow: true,
							vueRules:{required}
						},
						{
							// attrSelectList [{id: id, name: name, ...}] and attrSelectedList [name1, name2, ...] are necessary for SelectM
							attrName: 'roles',
							attrType: 'SelectM',
							attrCol: 'col-md-12',
							attrValue: this.row ? roleSelected : [],
							attrReadOnly: false,
							attrRequired: false,
							attrDisplay: editPwd,
							attrSelectList: this.roleslist,
							attrSelectedList: attrSelectedList,
							attrSelectOption: 'authority',
							attrOnRow: true,
							vueRules:{required}
						},
						
					];
					// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
					if(this.row && this.row.username && type === 'editPwd')
						this.vueRules = {
							form: {
								password :{required, minLength: minLength(5)}
							}
						}
					else if(this.row && this.row.username)
						this.vueRules = {
							form: {
								email : {required, email},
								username : {required, minLength: minLength(3)},
								// password :{required},
								passwordExpiration :{required},
								personId : {required},
								enabled : {required},
								userTitle: {required},
								roles : {required}
							}
						} 						
					else
						this.vueRules = {
							form: {
								email : {required, email},
								username : {required, minLength: minLength(3)},
								password :{required, minLength: minLength(5)},
								passwordExpiration :{required},
								enabled : {required},
								personId : {required},
								userTitle: {required},
								roles : {required}
							}
						}
					this.buildFormModel();
				})
				.catch((error) => {
					if (error.response)
						this.modalShow = true;
				});
					
			} 
			else if (this.instanceClass === 'role') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'authority',
						attrType: 'String',
						attrCol: 'col-md-12',
						attrValue: this.row ? this.row.authority : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					
				];
				this.buildFormModel();
						
			} 
			else if (this.instanceClass === 'rule') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'controllerName',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.controllerName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					{
						attrName: 'actionName',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.actionName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					
					{
						attrName: 'name',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.name : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					
				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'requestmap') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'url',
						attrType: 'String',
						attrCol: 'col-md-5',
						attrValue: this.row ? this.row.url : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					{
						attrName: 'configAttribute',
						attrType: 'String',
						attrCol: 'col-md-6',
						attrValue: this.row ? this.row.configAttribute : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					
					{
						attrName: 'httpMethod',
						attrType: 'String',
						attrCol: 'col-md-12',
						attrValue: this.row ? this.row.httpMethod : '',
						attrReadOnly: false,
						attrRequired: false,
						attrDisplay: ''
					},
					
				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'secright') {
				let attrSelectListRole = [];
				await this.$store.dispatch('axiosGet', {
						url: '/api/role?max=100',
					})
					.then((response) => {
						attrSelectListRole = response.data;

						this.dataMapShow.attrsList = [
							{
								attrName: 'role',
								attrType: 'Select',
								attrCol: 'col-md-12',
								attrValue: this.row ? this.row.role.id : '',
								attrReadOnly: false,
								attrRequired: false,
								attrDisplay: '',
								attrSelectList: attrSelectListRole,
								attrSelectOption: 'authority',
								vueRules:{required}

							},
							{
								attrName: 'permissions',
								attrType: 'String',
								attrCol: 'col-md-12',
								attrValue: this.row ? this.row.permissions : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required}
							},
						];
						// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
						this.vueRules = {
							form: {
								role :{required},
								permissions :{required}
							}
						}
						this.buildFormModel();
					})
					.catch((error) => {
						this.modalShow = true;
					});
			}
			else if (this.instanceClass === 'secuserlog') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'user.username',
						attrType: 'String',
						attrCol: 'col-md-6', 
						attrValue: this.row ? this.row.user.username : '',
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true},
					},
					{
						attrName: 'ipAddress',
						attrType: 'String',
						attrCol: 'col-md-6', 
						attrValue: this.row ? this.row.ipAddress : '',
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true},
					},
					{
						attrName: 'sessionId',
						attrType: 'String',
						attrCol: 'col-md-6', 
						attrValue: this.row ? this.row.sessionId : '',
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true},
					},
					{
						attrName: 'startConnection',
						attrType: 'String',
						attrCol: 'col-md-6',
						attrValue: this.row ? this.$moment(this.row.startConnection).format('DD/MM/YYYY HH:mm:ss') : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						veeRules:{required:true}      
					},
					{
						attrName: 'fullyLoggedIn',
						attrType: 'String',
						attrCol: 'col-md-6', 
						attrValue: this.row.fullyLoggedIn ? this.$t('secuserlog.connected') : this.$t('secuserlog.connectionAttempt'),
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true},
					}
				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'nottypemsg') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'shortName',
						attrType: 'String',
						attrCol: 'col-md-5',
						attrValue: this.row ? this.row.shortName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					{
						attrName: 'name',
						attrType: 'String',
						attrCol: 'col-md-7',
						attrValue: this.row ? this.row.name : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}

					},
				];
				this.buildFormModel();
			} 
			else if (this.instanceClass === 'notgenericmsg') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'shortName',
						attrType: 'String',
						attrCol: 'col-md-3',
						attrValue: this.row ? this.row.shortName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					{
						attrName: 'name',
						attrType: 'String',
						attrCol: 'col-md-9',
						attrValue: this.row ? this.row.name : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}

					},
					{
						attrName: 'listCodeProcStepServ',
						attrType: 'String',
						attrCol: 'col-md-12',
						attrValue: this.row ? this.row.listCodeProcStepServ : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: ''
					},
					{
						attrName: 'messageTitle',
						attrType: 'String',
						attrCol: 'col-md-12',
						attrValue: this.row ? this.row.messageTitle : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required}
					},
					{
						attrName: 'messageText',
						// attrType: 'TextArea',
						attrType: 'ckeditor',
						attrCol: 'col-md-12',
						attrValue: this.row ? this.row.messageText : '',
						attrReadOnly: false,
						attrRequired: false,
						attrDisplay: '',
					},
				];
				this.buildFormModel();
			} 
			else if (this.instanceClass === 'notmessage') {
				let attrSelectListNotType = [];
				let attrSelectListSecUser = [];

				await this.$store
					.dispatch('axiosGet', {
						url: '/api/nottypemsg?max=100',
					})
					.then(async (response) => {
						attrSelectListNotType = response.data;

						await this.$store
							.dispatch('axiosGet', {
								url: '/api/secuser?max=100',
							})
							.then((response) => {
								attrSelectListSecUser = response.data;

								this.dataMapShow.attrsList = [
									{
										attrName: 'notTypeMsg',
										attrType: this.modalType === 'show' ? 'String' : 'Select',
										attrCol: 'col-md-6',
										attrValue: this.row ? (this.modalType === 'show' ? this.row.notTypeMsgLib : this.row.notTypeMsg): '',
										attrReadOnly: false,
										attrRequired: true,
										attrSelectList: attrSelectListNotType,
										attrSelectOption: 'name',
										attrDisplay: '',
										vueRules:{required}
									},
									{
										attrName: 'senderId',
										attrType: 'String',
										attrCol: 'col-md-4',
										attrValue: this.row? this.row.recipientInfo: this.$store.getters.uid,
										attrReadOnly: false,
										attrRequired: true,
										attrDisplay: 'none',
										vueRules:{required}
									},
									{
										attrName: 'recipientId',
										attrType: this.modalType === 'show' ? 'String' : 'Select',
										attrCol: 'col-md-6',
										attrValue: this.row ? (this.modalType === 'show' ? this.row.recipientInfo : this.row.recipientInfo): '',
										attrReadOnly: false,
										attrRequired: true,
										attrSelectList: attrSelectListSecUser,
										attrSelectOption: 'name',
										attrDisplay: '',
										vueRules:{required}
									},
									{
										attrName: 'messageTitle',
										attrType: 'String',
										attrCol: 'col-md-6',
										attrValue: this.row ? this.row.messageTitle : '',
										attrReadOnly: false,
										attrRequired: true,
										attrDisplay: '',
										vueRules:{required}
									},
									{
										attrName: 'attachment',
										attrType: 'File',
										attrCol: 'col-md-6',
										attrValue: this.row ? this.row.attachment : '',
										attrReadOnly: false,
										attrRequired: false,
										attrDisplay: '',
									
									},
									{
										attrName: 'messageText',
										attrType: 'TextArea',
										attrCol: 'col-md-12',
										attrValue: this.row ? this.row.messageText : '',
										attrReadOnly: false,
										attrRequired: false,
										attrDisplay: '',
									},
									{
										attrName: 'messageTextShort',
										attrType: 'TextArea',
										attrCol: 'col-md-12',
										attrValue: this.row ? this.row.messageTextShort : '',
										attrReadOnly: false,
										attrRequired: false,
										attrDisplay: '',
										vueRules:{maxLength: maxLength(144)}									
									},
									
								];
								this.buildFormModel();
							})
							.catch((error) => {
								this.modalShow = true;
							});
					})
					.catch((error) => {
						this.modalShow = true;
					});
			}
			// PERSON
			else if (this.instanceClass === 'prstype') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'typeCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.typeCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'typeName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.typeName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'prsfunction') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'functionCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.functionCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}

					},
					{
						attrName: 'functionName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.functionName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'prsservice') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'serviceCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.serviceCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'serviceName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.serviceName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'prsteam') {
				let attrSelectListType = [
					{ value: 'Production' },
					{ value: 'Emballage' }
				]
				let attrSelectListPerson = [];

				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// EP -> 1
				strParams = strParams+"&aliasList=_prsType"
				strParams = strParams+"&params1=_prsType.id&valParams1="+1+"&logParams1=eqL"
				strParams = strParams+"&params2=active&valParams2="+true+"&logParams2=eqB"


				await this.$store.dispatch('axiosGet', {
						url: '/api/prsperson/getbycriteria?' + strParams
					})
					.then((response) => {
						attrSelectListPerson = response.data;

						this.dataMapShow.attrsList = [
							{
								attrName: 'teamName',
								attrType: 'String',
								attrCol: 'col-md-7',
								attrValue: this.row ? this.row.teamName : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required, maxLength: maxLength(128)}
							},
							{ // a revoir avec Opt PROD, EMB
								attrName: 'teamType',
								attrType: 'Select',
								attrCol: 'col-md-5',
								attrValue: this.row ? this.row.teamType : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								attrSelectList: attrSelectListType,
								attrSelectOption: 'value',
								vueRules:{required}
							},
							{
								attrName: 'prsPerson',
								attrType: 'Select',
								attrCol: 'col-md-6',
								attrValue: (this.row && this.row.prsPerson) ? this.row.prsPerson.id : '',
								attrReadOnly: false,
								attrRequired: false,
								attrDisplay: '',
								attrSelectList: attrSelectListPerson,
								attrSelectOption: 'fullName',
								vueRules:{required}
							},
							{
								attrName: 'timeStart',
								attrType: 'Integer',
								attrCol: 'col-md-3',
								attrValue: this.row ? this.row.timeStart : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required}
							},
							{
								attrName: 'timeEnd',
								attrType: 'Integer',
								attrCol: 'col-md-3',
								attrValue: this.row ? this.row.timeEnd : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required}
							},
						];
						// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
						this.vueRules = {
							form: {
								teamName :{required, maxLength: maxLength(128)},
								teamType :{required},
								prsPerson :{required},
								timeStart :{required},
								timeEnd :{required}
							}
						}
						this.buildFormModel();
					})
				.catch((error) => {
					this.modalShow = true;
				});
			}
			else if (this.instanceClass === 'prsstore') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'storeCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.storeCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(10)}
					},
					{
						attrName: 'storeName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.storeName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			// MVT
			else if (this.instanceClass === 'mvttypemvt') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'typeMvtCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.typeMvtCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'typeMvtName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.typeMvtName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'mvttypedep') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'typeDepCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.typeDepCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'typeDepName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.typeDepName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'mvtbank') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'bankCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.bankCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(20)}
					},
					{
						attrName: 'bankName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.bankName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			// SERV
			else if (this.instanceClass === 'servunit') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'unitCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.unitCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'unitName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.unitName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'servformat') {
				let attrSelectListUnit = [];
				await this.$store.dispatch('axiosGet', {
						url: '/api/servunit?max=100',
					})
					.then((response) => {
						attrSelectListUnit = response.data;
						this.dataMapShow.attrsList = [
							{
								attrName: 'formatCode',
								attrType: 'String',
								attrCol: 'col-md-4',
								attrValue: this.row ? this.row.formatCode : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required, maxLength: maxLength(5)}
							},
							{
								attrName: 'formatName',
								attrType: 'String',
								attrCol: 'col-md-8',
								attrValue: this.row ? this.row.formatName : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required, maxLength: maxLength(128)}
							},
							{
								attrName: 'quantity',
								attrType: 'Integer',
								attrCol: 'col-md-4',
								attrValue: this.row ? this.row.quantity : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required}
							},
							{
								attrName: 'nombre',
								attrType: 'Integer',
								attrCol: 'col-md-4',
								attrValue: this.row ? this.row.nombre : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required}
							},
							{
								attrName: 'servUnit',
								attrType: 'Select',
								attrCol: 'col-md-4',
								attrValue: this.row ? this.row.servUnit.id : '',
								attrReadOnly: false,
								attrRequired: false,
								attrDisplay: '',
								attrSelectList: attrSelectListUnit,
								attrSelectOption: 'unitName',
								vueRules:{required}
							}

						];
						// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
						this.vueRules = {
							form: {
								formatCode :{required, maxLength: maxLength(5)},
								formatName :{required, maxLength: maxLength(128)},
								quantity :{required},
								nombre :{required},
								servUnit :{required}
							}
						}
						this.buildFormModel();
					})
				.catch((error) => {
					this.modalShow = true;
				});
			}
			else if (this.instanceClass === 'servcategory') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'categoryCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.categoryCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'categoryName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.categoryName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'servtypecat') {
				let attrSelectListCategory = [];
				
				await this.$store.dispatch('axiosGet', {
						url: '/api/servcategory?max=100',
					})
					.then((response) => {
						attrSelectListCategory = response.data;
						this.dataMapShow.attrsList = [
							{
								attrName: 'typeCatCode',
								attrType: 'String',
								attrCol: 'col-md-4',
								attrValue: this.row ? this.row.typeCatCode : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required, maxLength: maxLength(5)}
							},
							{
								attrName: 'typeCatName',
								attrType: 'String',
								attrCol: 'col-md-8',
								attrValue: this.row ? this.row.typeCatName : '',
								attrReadOnly: false,
								attrRequired: true,
								attrDisplay: '',
								vueRules:{required, maxLength: maxLength(128)}
							},
							{
								attrName: 'servCategory',
								attrType: 'Select',
								attrCol: 'col-md-12',
								attrValue: this.row ? this.row.servCategory.id : '',
								attrReadOnly: false,
								attrRequired: false,
								attrDisplay: '',
								attrSelectList: attrSelectListCategory,
								attrSelectOption: 'categoryName',
								vueRules:{required}
							}
						];
						// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
						this.vueRules = {
							form: {
								typeCatCode :{required, maxLength: maxLength(5)},
								typeCatName :{required, maxLength: maxLength(128)},
								servCategory :{required}
							}
						}
						this.buildFormModel();

					})
				.catch((error) => {
					this.modalShow = true;
				});
				
			}
			else if (this.instanceClass === 'servservice') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'serviceCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.serviceCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'serviceName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.serviceName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'servstatus') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'code',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.code : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(2)}
					},
					{
						attrName: 'statusName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.statusName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'servtype') {
				let attrSelectListCategory = [];
				let attrSelectListUnit = [];
				let attrSelectListTypeCat = [];
				let attrSelectListFormat = [];
				await this.$store.dispatch('axiosGet', {
						url: '/api/servcategory?max=100',
					})
					.then((response) => {
						attrSelectListCategory = response.data;
						this.$store.dispatch('axiosGet', {
							url: '/api/servunit?max=100',
						})
						.then((response) => {
							attrSelectListUnit = response.data;
							this.$store.dispatch('axiosGet', {
								url: '/api/servtypecat?max=100',
							})
							.then((response) => {
								attrSelectListTypeCat = response.data;
								this.$store.dispatch('axiosGet', {
									url: '/api/servformat?max=100',
								})
								.then((response) => {
									attrSelectListFormat = response.data;
									
									this.dataMapShow.attrsList = [
										{
											attrName: 'servCategory',
											attrType: 'Select',
											attrCol: 'col-md-3',
											attrValue: this.row ? this.row.servCategory.id : '',
											attrReadOnly: false,
											attrRequired: true,
											attrDisplay: '',
											attrSelectList: attrSelectListCategory,
											attrSelectOption: 'categoryName',
											vueRules:{required}
										},
										{
											attrName: 'servUnit',
											attrType: 'Select',
											attrCol: 'col-md-3',
											attrValue: this.row ? this.row.servUnit.id : '',
											attrReadOnly: false,
											attrRequired: true,
											attrDisplay: '',
											attrSelectList: attrSelectListUnit,
											attrSelectOption: 'unitName',
											vueRules:{required}
										},
										{
											attrName: 'servTypeCat',
											attrType: 'Select',
											attrCol: 'col-md-3',
											attrValue: (this.row && this.row.servTypeCat) ? this.row.servTypeCat.id : '',
											attrReadOnly: false,
											attrRequired: false,
											attrDisplay: '',
											attrSelectList: attrSelectListTypeCat,
											attrSelectOption: 'typeCatName',
											// vueRules:{required}
										},
										{
											attrName: 'servFormat', 
											attrType: 'Select',
											attrCol: 'col-md-3',
											attrValue: (this.row && this.row.servFormat) ? this.row.servFormat.id : '',
											attrReadOnly: false,
											attrRequired: false,
											attrDisplay: '',
											attrSelectList: attrSelectListFormat,
											attrSelectOption: 'formatName',
											// vueRules:{required}
										},
										{
											attrName: 'typeCode',
											attrType: 'String',
											attrCol: 'col-md-3',
											attrValue: this.row ? this.row.typeCode : '',
											attrReadOnly: false,
											attrRequired: true,
											attrDisplay: '',
											vueRules:{required}
										},
										{
											attrName: 'typeName',
											attrType: 'String',
											attrCol: 'col-md-6',
											attrValue: this.row ? this.row.typeName : '',
											attrReadOnly: false,
											attrRequired: true,
											attrDisplay: '',
											vueRules:{required}
										},
										{
											attrName: 'cost',
											attrType: 'Double',
											attrCol: 'col-md-3',
											attrValue: this.row ? this.row.cost : 0,
											attrReadOnly: false,
											attrRequired: true,
											attrDisplay: '',
											vueRules:{required}
										}
									];
									// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
									this.vueRules = {
										form: {
											typeCode :{required},
											typeName :{required},
											servCategory :{required},
											servUnit :{required},
											cost :{required}
										}
									}
									this.buildFormModel();
								})
								.catch((error) => {
									this.modalShow = true;
								});
							})
							.catch((error) => {
								this.modalShow = true;
							});
						})
						.catch((error) => {
							this.modalShow = true;
						});
					})
				.catch((error) => {
					this.modalShow = true;
				});
			}
			else if (this.instanceClass === 'servtypees') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'typeESCode',
						attrType: 'String',
						attrCol: 'col-md-4',
						attrValue: this.row ? this.row.typeESCode : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(5)}
					},
					{
						attrName: 'typeESName',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.typeESName : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						vueRules:{required, maxLength: maxLength(128)}
					}

				];
				this.buildFormModel();
			}
			else if (this.instanceClass === 'servtypestockes') {
				let attrSelectListType = [];
				let attrSelectListService = [];
				let attrSelectListTypeES = [];

				await this.$store.dispatch('axiosGet', {
						url: '/api/servtype?max=100',
					})
					.then((response) => {
						attrSelectListType = response.data;
						this.$store.dispatch('axiosGet', {
							url: '/api/servservice?max=100',
						})
						.then((response) => {
							attrSelectListService = response.data;
							this.$store.dispatch('axiosGet', {
								url: '/api/servtypees?max=100',
							})
							.then((response) => {
								attrSelectListTypeES = response.data;

								this.dataMapShow.attrsList = [
									{
										attrName: 'servTypeES',
										attrType: 'Select',
										attrCol: 'col-md-4',
										attrValue: this.row ? this.row.servTypeES.id : '',
										attrReadOnly: false,
										attrRequired: true,
										attrDisplay: '',
										attrSelectList: attrSelectListTypeES,
										attrSelectOption: 'typeESName',
										vueRules:{required}
									},
									{
										attrName: 'servService',
										attrType: 'Select',
										attrCol: 'col-md-4',
										attrValue: this.row ? this.row.servService.id : '',
										attrReadOnly: false,
										attrRequired: true,
										attrDisplay: '',
										attrSelectList: attrSelectListService,
										attrSelectOption: 'serviceName',
										vueRules:{required}
									},
									
									{
										attrName: 'servType',
										attrType: 'Select',
										attrCol: 'col-md-4',
										attrValue: this.row ? this.row.servType.id : '',
										attrReadOnly: false,
										attrRequired: true,
										attrDisplay: '',
										attrSelectList: attrSelectListType,
										attrSelectOption: 'typeName',
										vueRules:{required}
									},
									
									
									{
										attrName: 'quantity',
										attrType: 'Integer',
										attrCol: 'col-md-6',
										attrValue: this.row ? this.row.quantity : '',
										attrReadOnly: false,
										attrRequired: true,
										attrDisplay: '',
										vueRules:{required}
									},
									{
										attrName: 'cost',
										attrType: 'Double',
										attrCol: 'col-md-6',
										attrValue: this.row ? this.row.cost : '',
										attrReadOnly: false,
										attrRequired: true,
										attrDisplay: '',
										vueRules:{required}
									}
								];
								// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
								this.vueRules = {
									form: {
										servTypeES :{required},
										servService :{required},
										servType :{required},
										quantity :{required},
										cost :{required}
									}
								}
								this.buildFormModel();
							})
							.catch((error) => {
								this.modalShow = true;
							});
						})
						.catch((error) => {
							this.modalShow = true;
						});
					})
				.catch((error) => {
					this.modalShow = true;
				});
			}
			else if (this.instanceClass === 'servtypeserv') {
				let attrSelectListType = [];
				let attrSelectListService = [];

				await this.$store.dispatch('axiosGet', {
						url: '/api/servtype?max=100',
					})
					.then((response) => {
						attrSelectListType = response.data;
						this.$store.dispatch('axiosGet', {
							url: '/api/servservice?max=100',
						})
						.then((response) => {
							attrSelectListService = response.data;
							this.dataMapShow.attrsList = [
								
								{
									attrName: 'servService',
									attrType: 'Select',
									attrCol: 'col-md-4',
									attrValue: this.row ? this.row.servService.id : '',
									attrReadOnly: false,
									attrRequired: true,
									attrDisplay: '',
									attrSelectList: attrSelectListService,
									attrSelectOption: 'serviceName',
									vueRules:{required}
								},
								
								{
									attrName: 'servType',
									attrType: 'Select',
									attrCol: 'col-md-4',
									attrValue: this.row ? this.row.servType.id : '',
									attrReadOnly: false,
									attrRequired: true,
									attrDisplay: '',
									attrSelectList: attrSelectListType,
									attrSelectOption: 'typeName',
									vueRules:{required}
								},
								{
									attrName: 'stock',
									attrType: 'Integer',
									attrCol: 'col-md-4',
									attrValue: this.row ? this.row.stock : '',
									attrReadOnly: false,
									attrRequired: true,
									attrDisplay: '',
									vueRules:{required}
								}
								
							];
							// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
							this.vueRules = {
								form: {
									servService :{required},
									servType :{required},
									stock :{required}
								}
							}
							this.buildFormModel();
							
						})
						.catch((error) => {
							this.modalShow = true;
						});
					})
				.catch((error) => {
					this.modalShow = true;
				});
			}
			else if (this.instanceClass === 'servtypeservstore') {
				let attrSelectListStore = [];
				let attrSelectListTypeServ = [];

				await this.$store.dispatch('axiosGet', {
						url: '/api/prsstore?max=100',
					})
					.then((response) => {
						attrSelectListStore = response.data;
						this.$store.dispatch('axiosGet', {
							url: '/api/servtypeserv?max=100',
						})
						.then((response) => {
							attrSelectListTypeServ = response.data;
							this.dataMapShow.attrsList = [
								
								{
									attrName: 'servTypeServ',
									attrType: 'Select',
									attrCol: 'col-md-6',
									attrValue: this.row ? this.row.servTypeServ.id : '',
									attrReadOnly: false,
									attrRequired: true,
									attrDisplay: '',
									attrSelectList: attrSelectListTypeServ,
									attrSelectOption: 'lib',
									vueRules:{required}
								},
								
								{
									attrName: 'prsStore',
									attrType: 'Select',
									attrCol: 'col-md-3',
									attrValue: this.row ? this.row.prsStore.id : '',
									attrReadOnly: false,
									attrRequired: true,
									attrDisplay: '',
									attrSelectList: attrSelectListStore,
									attrSelectOption: 'storeName',
									vueRules:{required}
								},
								{
									attrName: 'stock',
									attrType: 'Integer',
									attrCol: 'col-md-3',
									attrValue: this.row ? this.row.stock : '',
									attrReadOnly: false,
									attrRequired: true,
									attrDisplay: '',
									vueRules:{required}
								}
								
							];
							// FORCE INIT VUELIDATE WITH AWAIT FUNCTION
							this.vueRules = {
								form: {
									servTypeServ :{required},
									prsStore :{required},
									stock :{required}
								}
							}
							this.buildFormModel();
							
						})
						.catch((error) => {
							this.modalShow = true;
						});
					})
				.catch((error) => {
					this.modalShow = true;
				});
			}
			else if (this.instanceClass === 'repmodel') {
				/*let procedures = await this.$store
				.dispatch('axiosGet', {
					url: '/api/dosprocessformality?max=100',
				});*/
				this.dataMapShow.attrsList = [
					{
						attrName: 'title', 
						attrType: 'String', 
						attrValue: this.row ? this.row.title : '', 
						attrCol: 'col-md-5', 
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						vueRules:{required}
					},
					{
						attrName: 'description', 
						attrType: 'String', 
						attrValue: this.row ? this.row.description : '', 
						attrCol: 'col-md-7', 
						attrReadOnly: false, 
						attrRequired: false, 
						attrDisplay: '',
						vueRules:{required}

					},
					{
						attrName: 'name', 
						attrType: 'String', 
						attrValue: this.row ? this.row.name : '', 
						attrCol: 'col-md-5', 
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						vueRules:{required}
					},
					{
						attrName: 'jrxmlFile', 
						attrType: 'File',  
						attrValue: this.row ? '' : '', 
						attrCol: 'col-md-7', 
						attrReadOnly: false, 
						attrRequired: false, 
						attrDisplay: '',
						// vueRules:{required}
					},
					/*{
						attrName: 'codeAccess', 
						attrType: 'CheckBoxString', 
						attrValue: this.row ? this.row.codeAccess?.split(',') : [],
						attrCol: 'col-md-12', 
						attrReadOnly: false, 
						attrRequired: false, 
						attrDisplay: '',
						attrSelectList: procedures.data.map(proc => ({ value: proc.processDefKey, text: proc.processName })),
						attrSelectOption: 'text',
						attrSelected: this.row ? this.row?.codeAccess?.split(',') : [],
						veeRules:{required:false}
					},*/
					
				];
				this.buildFormModel();
			}

			/*else if (this.instanceClass === 'gissequence') {
				this.dataMapShow.attrsList = [
					{
						attrName: 'name',
						attrType: 'String',
						attrCol: 'col-md-8',
						attrValue: this.row ? this.row.name : '',
						attrReadOnly: false,
						attrRequired: true,
						attrDisplay: '',
						veeRules:{required:true, max:50},
						veeRequired:true,
						veeMax:5

					},
					{
						attrName: 'year',
						attrType: 'Integer', 
						attrCol: 'col-md-4', 
						attrValue: this.row ? this.row.year : '', 
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true}
					},
					{
						attrName: 'month',
						attrType: 'Integer', 
						attrCol: 'col-md-4', 
						attrValue: this.row ? this.row.month : '', 
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true}
					},
					{
						attrName: 'counter',
						attrType: 'Integer', 
						attrCol: 'col-md-4', 
						attrValue: this.row ? this.row.counter : '', 
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true}
					},
					
				];
				this.buildFormModel();
			} 
			
			else if (this.instanceClass === 'repgismodel') {
				let procedures = await this.$store
				.dispatch('axiosGet', {
					url: '/api/dosprocessformality?max=100',
				});
				this.dataMapShow.attrsList = [
					{
						attrName: 'title', 
						attrType: 'String', 
						attrValue: this.row ? this.row.title : '', 
						attrCol: 'col-md-5', 
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true}
					},
					{
						attrName: 'description', 
						attrType: 'String', 
						attrValue: this.row ? this.row.description : '', 
						attrCol: 'col-md-7', 
						attrReadOnly: false, 
						attrRequired: false, 
						attrDisplay: '',

					},
					{
						attrName: 'name', 
						attrType: 'String', 
						attrValue: this.row ? this.row.name : '', 
						attrCol: 'col-md-5', 
						attrReadOnly: false, 
						attrRequired: true, 
						attrDisplay: '',
						veeRules:{required:true}
					},
					{
						attrName: 'jrxmlFile', 
						attrType: 'File',  
						attrValue: this.row ? '' : '', 
						attrCol: 'col-md-7', 
						attrReadOnly: false, 
						attrRequired: false, 
						attrDisplay: '',
					},
					{
						attrName: 'codeAccess', 
						attrType: 'CheckBoxString', 
						attrValue: this.row ? this.row.codeAccess?.split(',') : [],
						attrCol: 'col-md-12', 
						attrReadOnly: false, 
						attrRequired: false, 
						attrDisplay: '',
						attrSelectList: procedures.data.map(proc => ({ value: proc.processDefKey, text: proc.processName })),
						attrSelectOption: 'text',
						attrSelected: this.row ? this.row?.codeAccess?.split(',') : [],
						veeRules:{required:false}
					},
					
				];
				this.buildFormModel();
			}*/
			
			
			
		},
		async axiosShow(id, type) {
			try {
				if (type !== 'new') {
					if (id && id !== '') {
						await this.$store.dispatch('axiosGet', {
							domain: (this.instanceClass === 'notalert') ? 'notmessage' : this.instanceClass,
							id: id,
						})
						.then((response) => {
							this.row = response.data;
							this.dataMapShow.infos.id = response.data.id;
							this.handleResult(type);
						})
						.catch((error) => {
							this.modalShow = true;
						});
					} 
					else
						this.handleResult(type);
				} 
				else {
					this.dataMapShow.infos.id = NaN;
					this.handleResult(type);
				}
			} 
			catch (e) {
				this.modalShow = false;
			}
		},
		convertSpecialInputs() {
			// Delete password entry for edit
			if (this.instanceClass === 'user' && this.form.password)
				// delete this.form.password;
			if (this.instanceClass === 'repmodel')
				this.form.codeAccess = this.form.codeAccess ? this.form.codeAccess?.join(',') : []
			let tempFormData = null
			for (let index = 0; index < this.dataMapShow.attrsList.length; index++) {
				const element = this.dataMapShow.attrsList[index];
				if(element) {
					switch (element.attrType) {
						case 'Date':
							if(this.datepicker.selectedDate)
								this.form[element.attrName] = this.datepicker.selectedDate
							break;
						case 'SelectM':         
							tempFormData = JSON.parse(JSON.stringify(this.form[element.attrName]))
							if(element.attrName === 'billingServiceType')              
								this.form[element.attrName] = tempFormData.map(selection => ({id:selection.id}))
							else if(element.attrName === 'paymentMethod')
								this.form[element.attrName] = {id: tempFormData.id}
							else if (tempFormData && tempFormData.length > 0) {               
								if (element.attrName === 'roles') {
									this.form[element.attrName] = tempFormData.map(selection => selection.id)
									this.form['camroles'] = tempFormData.map(selection => selection.name)
								} 
								else {
									if (element.attrName !== 'camroles')
										this.form[element.attrName] = tempFormData.map(selection => selection.id)
								}
							}
							break;
						default:
							break;
					}
				} 
				else {
					// console.log('attrList empty')
				}
			}
		},
		async handleSubmit(id) {
			// setup set in Modal
			let validated = await this.v$.$validate()
			// console.log('validated == ', validated)
			// console.log( 'this.v$.form = ', this.v$.form)
			// pre-controle with vueRules
			if (!validated)
				return;
			else {
				// this.msgError = ''
				this.$store.dispatch('initFlash');
				this.axiosPost(id);
			}
		},
		async axiosPost(id) {
			try {
				// New Fusion avec submitFile
				let data = this.form
				if(this.file.length > 0){
					let formData = new FormData();
					for (const [key, value] of Object.entries(this.form)) {
						// console.log(key, value);
						// cas repmode
						if(key === 'jrxmlFile')
							this.file.map((file, index) => {
								formData.append(key, file);
							});
						else
							formData.append(key, value);
					}
					data = formData;
				}

				await this.$nextTick(async () => {
					this.convertSpecialInputs()
					if (id) {
						// console.log(this.form.roles)
						// if(this.form["currency.type"])
						// 	this.form.currency = { id: this.form["currency.type"] }
						
						await this.$store.dispatch('axiosPut', {
							domain: this.instanceClass,
							id: id,
							data: data // this.form,
						})
						.then((res) => {
							// this.$refs.myTable.refresh();
							this.$emit('refreshDataTable', 'updated' );
							this.$nextTick(() => {
								let msg = this.$t(this.instanceClass + ".label") + " "+id;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.updated.message', { obj: msg})
								});
							});

							// Hide the modal manually
							this.handleCancel();
						})
						.catch((error) => {
							this.$store.getters.getErrorMsgFormatted(error);
						});
					} 
					else {
						await this.$store.dispatch('axiosPost', {
							domain: this.instanceClass,
							// data: data,
							data: data // this.form,
						})
						.then((res) => {
							this.$emit('refreshDataTable', 'created' );
							this.$nextTick(() => {
								let msg = this.$t(this.instanceClass + ".label") + " "+ res?.data.id;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.created.message', { obj: msg})
								});
							});
							
							// Hide the modal manually
							this.handleCancel();
						})
						.catch((error) => {
							this.$store.getters.getErrorMsgFormatted(error);
						});
					}
				})
			} 
			catch (e) {
				// console.log('Error : ', e);
			}
		},
		async axiosDel(id) {
			try {
				if (id) {
					await this.$store.dispatch('axiosDelete', {
						domain: this.instanceClass,
						id: id,
					})
					.then((res) => {
						this.$emit('refreshDataTable', 'deleted' );
						this.$nextTick(() => {
							let msg = this.$t(this.instanceClass + ".label") + " "+id;
							this.$store.dispatch('showToast', {
								type: 'error', message: this.$t('toast.deleted.message', { obj: msg})
							});
						});
						this.handleCancel()
					})
					.catch((error) => {
						this.modalShow = true;
					});
				}
			} 
			catch (e) {
				// console.log('e', e);
			}
		}
	},
};